import Lookup from 'src/componentes/select-async';
import ItemList from 'src/paginas/item';

const ItemLookup = (props) => {
  return (
    <Lookup
      valueKey="id"
      labelKey="nome"
      showSearch
      showNew={false}
      url="/ItemLookup"
      clearable={true}
      searchComponent={ItemList}
      {...props}
    />
  );
};

export default ItemLookup;
